/** @format */

import {CheckIcon, MinusIcon} from '@heroicons/react/solid'
import * as Primitive from '@radix-ui/react-checkbox'
import React, {ReactNode, useId} from 'react'

export type {CheckedState} from '@radix-ui/react-checkbox'

type CheckboxFieldProps = {
  label: ReactNode
} & Omit<Primitive.CheckboxProps, 'className'>

export function CheckboxField(props: CheckboxFieldProps) {
  const genId = useId()
  const {id = genId, label, ...checkboxProps} = props
  return (
    <div className="flex items-start gap-2">
      <div className="inline-flex flex-none py-1">
        <Checkbox {...checkboxProps} id={id} />
      </div>
      <label htmlFor={id}>{label}</label>
    </div>
  )
}

type CheckboxProps = Omit<Primitive.CheckboxProps, 'className'>

export function Checkbox(props: CheckboxProps) {
  return (
    <Primitive.Checkbox
      {...props}
      className="group inline-flex h-4 w-4 flex-none cursor-pointer rounded border border-gray-300 hover:border-gray-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-300 disabled:cursor-default disabled:border-gray-300 disabled:bg-gray-200 data-[state=checked]:border-primary data-[state=indeterminate]:border-primary data-[state=checked]:bg-primary data-[state=indeterminate]:bg-primary"
    >
      <CheckIcon className="hidden text-white group-data-[state=checked]:block" />
      <MinusIcon className="hidden text-white group-data-[state=indeterminate]:block" />
    </Primitive.Checkbox>
  )
}
